export default __webpack_public_path__ + "static/media/2063.92b55a7e.png";